import React from "react";
import CalendarioPedidos from "../../../components/Pedidos/Calendario";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as pedidoActions from "../../../reducers/pedidosReducer/actions";
import { calendarioPedidosReducerDataSelector } from "../../../selectors/pedidosSelector";
import { instalacionSelector, sucursalSelector } from "../../../selectors/sessionSelector";
import moment from "moment";

const Calendario = ({ sagaGetCalendarioPedidos, calendarioPedidos, sucursal }) => {
  const today = moment().format("YYYY-MM-DD");
  const [value, setValue] = React.useState(0);
  const [valuePrev, setValuePrev] = React.useState(0);
  const [refresh, setRefresh] = React.useState(false);
  const [opened, setOpened] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [fecha, setFecha] = React.useState(today);
  const [fechaPrev, setFechaPrev] = React.useState(today);

  React.useEffect(() => {
    sagaGetCalendarioPedidos({
      idInstalacion: sucursal.idSucursal,
      fecha: fecha,
      type: value === 0 ? "pickup" : "delivery",
    });
    if (fecha !== fechaPrev || value !== valuePrev) {
      setValuePrev(value);
      setFechaPrev(fecha);
      setOpened(false);
    }
  }, [value, fecha, refresh, sagaGetCalendarioPedidos, sucursal.idSucursal, fechaPrev, valuePrev]);

  React.useEffect(() => {
    if (loaded) {
      localStorage.setItem("calendarData", JSON.stringify({ fecha, value, opened }));
    }
  }, [value, fecha, opened, loaded]);

  React.useEffect(() => {
    const calendarData = JSON.parse(localStorage.getItem("calendarData"));
    if (calendarData) {
      sagaGetCalendarioPedidos({
        idInstalacion: sucursal.idSucursal,
        fecha: today,
        type: calendarData.value === 0 ? "pickup" : "delivery",
      });
      setFecha(today);
      setFechaPrev(today);
      setValue(calendarData.value);
      setValuePrev(calendarData.value);
      setOpened(calendarData.opened);
    }
    setLoaded(true);

    window.onbeforeunload = function () {
      localStorage.removeItem("calendarData");
      return undefined;
    };
  }, [sagaGetCalendarioPedidos, sucursal.idSucursal, today]);

  return (
    <CalendarioPedidos
      {...{
        value,
        setValue,
        fecha,
        setFecha,
        calendarioPedidos,
        refresh,
        setRefresh,
        setOpened,
        opened,
      }}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...pedidoActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    calendarioPedidos: calendarioPedidosReducerDataSelector(state),
    instalacion: instalacionSelector(state),
    sucursal: sucursalSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Calendario);
